import Vue from 'vue';
import store from '@/store';
import * as types from './mutation-types';

export const check = () => Vue.$http.get('v1/auth/validate_token');

export const register = ({ commit }, user) => {
  const CONFIRM_URL = `${process.env.PROTOCOL}://${process.env.HOST}/login`;

  const u = user;
  u.confirm_success_url = CONFIRM_URL;

  Vue.$http.post('v1/auth', u)
    .then(() => {
      Vue.router.push({ name: 'login' });
      store.commit('alert/SUCCESS', 'An email has been sent to the provided email address for verification.');
    })
    .catch((error) => {
      if (error.response) {
        let errors = '';
        error.response.data.errors.full_messages.forEach((errorText) => {
          errors += `<p>${errorText}</p>`;
        });
        store.commit('alert/ERROR', errors);
      } else {
        store.commit('alert/ERROR', 'Something went wrong.');
      }
    });
};

export const login = ({ commit }, user) => {
  Vue.$http.post('v1/auth/sign_in', user)
    .then((response) => {
      commit(types.LOGIN, response.data.data);

      if (store.state.redirect.path !== undefined) {
        Vue.router.push(store.state.redirect.path);
        store.commit('redirect/CLEAR');
      } else {
        Vue.router.push({ name: 'home' });
      }

      store.commit('alert/SUCCESS', 'Successfully signed in!');
    })
    .catch((error) => {
      if (error.response) {
        let errors = '';
        error.response.data.errors.forEach((errorText) => {
          errors += `<p>${errorText}</p>`;
        });
        store.commit('alert/ERROR', errors);
      } else {
        store.commit('alert/ERROR', 'Something went wrong.');
      }
    });
};

export const logout = ({ commit }) => {
  Vue.$http.delete('v1/auth/sign_out')
  .then(() => {
    localStorage.removeItem('access-token');
    localStorage.removeItem('client');
    localStorage.removeItem('uid');
    localStorage.removeItem('token-type');

    commit(types.LOGOUT);
    Vue.router.push({ name: 'login' });
    store.commit('alert/SUCCESS', 'Successfully signed out!');
  })
  .catch(() => {
    localStorage.removeItem('access-token');
    localStorage.removeItem('client');
    localStorage.removeItem('uid');
    localStorage.removeItem('token-type');

    commit(types.LOGOUT);
    Vue.router.push({ name: 'login' });
    store.commit('alert/SUCCESS', 'Successfully signed out!');
  });
};

export default {
  register,
  login,
  logout,
  check,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js